export type DialogVariant = 'destructive' | 'warning' | 'confirm' | 'success';

export type DialogVariantStyle = {
  icon: string;
  iconClassName: string;
  buttonClassName: string;
};

/**
 * Single source of truth for the icon + color pairing of confirmation
 * dialogs and toasts, keyed by intent rather than feature, so the same
 * "destructive"/"warning"/"confirm"/"success" action always looks the same
 * everywhere it appears.
 */
export const DIALOG_VARIANT_STYLE: Record<DialogVariant, DialogVariantStyle> = {
  destructive: {
    icon: 'delete',
    iconClassName: 'bg-rose-100 text-rose-600 dark:bg-rose-950 dark:text-rose-400',
    buttonClassName:
      'bg-red-600 text-white hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-500',
  },
  warning: {
    icon: 'warning',
    iconClassName: 'bg-amber-100 text-amber-600 dark:bg-amber-950 dark:text-amber-400',
    buttonClassName:
      'bg-amber-600 text-white hover:bg-amber-700 dark:bg-amber-600 dark:hover:bg-amber-500',
  },
  confirm: {
    icon: 'help',
    iconClassName: 'bg-indigo-100 text-indigo-600 dark:bg-indigo-950 dark:text-indigo-400',
    buttonClassName:
      'bg-indigo-600 text-white hover:bg-indigo-700 dark:bg-indigo-600 dark:hover:bg-indigo-500',
  },
  success: {
    icon: 'check_circle',
    iconClassName: 'bg-green-100 text-green-600 dark:bg-green-950 dark:text-green-400',
    buttonClassName:
      'bg-green-600 text-white hover:bg-green-700 dark:bg-green-600 dark:hover:bg-green-500',
  },
};
